// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__206Tj","productName":"Table_productName__3poTE"};